import axios from "axios"
import { API_BASE_URL } from "../config"

export const manageMedicalRecordBulkCreate = async (facility_id: string, csv_data: string) => {
  // 改行コードを統一して分割（\r\n, \r, \n のいずれでも対応）
  const lines = csv_data
    .replace(/\r\n|\r/g, "\n")
    .trim()
    .split("\n")

  const records = lines.map((line) => {
    //console.log(line);
    const [
      room_no,
      name,
      initial,
      birthday,
      phone,
      device_place_1,
      device_place_2,
      device_place_3,
      device_place_4,
      device_place_5,
      device_place_6,
      device_place_7,
      device_place_8,
      device_place_9,
      device_place_10
    ] = line.split(",")
    //console.log(room_no);

    const ret: any = {
      room_no: room_no.trim(),
      name: name.trim(),
      initial: initial.trim(),
      birthday: birthday.trim(),
      phone: phone.trim()
    }

    if (device_place_1) ret.device_place_1 = device_place_1
    if (device_place_2) ret.device_place_2 = device_place_2
    if (device_place_3) ret.device_place_3 = device_place_3
    if (device_place_4) ret.device_place_4 = device_place_4
    if (device_place_5) ret.device_place_5 = device_place_5
    if (device_place_6) ret.device_place_6 = device_place_6
    if (device_place_7) ret.device_place_7 = device_place_7
    if (device_place_8) ret.device_place_8 = device_place_8
    if (device_place_9) ret.device_place_9 = device_place_9
    if (device_place_10) ret.device_place_10 = device_place_10

    return ret
  })

  // リクエストデータを作成
  const requestData = {
    session_code: localStorage.getItem("session_code"),
    facility_id: facility_id,
    medical_records: records
  }

  // APIリクエスト送信
  for (let i = 0; i < 3; i++) {
    try {
      const response = await axios.post(`${API_BASE_URL}/medical_record/bulk_create`, requestData)

      if (response.data.session_code) {
        localStorage.setItem("session_code", response.data.session_code)
      }
      return response.data
    } catch (error: any) {
      if (error.code && error.code == "ERR_NETWORK" && i != 2) {
        continue
      }
      throw error
    }
  }
}
